import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DwComponent, DwComponentType, DwExpressionService, DwMetaDataFormApi, DwMetaDataFormStateService, 
         DwMetaDataService, DwMetaDataServiceToken, DwSectionBaseComponent, DwUiConfigRegistryService, DwUIMetaDataConfig, DwUIMetaDataConfigToken, 
         DwLookupSearchType, DwOrmDataService, DwOrmDataServiceToken, DwContext, DwLookupInfo } 
         from '@devwareapps/devware-cap';
import { debounceTime } from 'rxjs/operators';
import { AppMetaDataLookups, AppMetaDataService } from '../../../../meta-data/app-meta-data.service';
import { AccidentsMetaDataItemNames, VehicleAccidentEntity, AccidentsMetaDataLookups } 
          from '../../meta-data/accidents-meta-data.service';
import { Observable, of } from 'rxjs';
import * as moment_ from 'moment';
import { exp } from 'mathjs';
const moment = moment_;

@DwComponent({
  name: 'Vehicle Accidents UI Util',
  key: 'vehicleAccidentsUiUtil',
  componentType: DwComponentType.formSection,
  isGlobal: false,
  parentItemName: AccidentsMetaDataItemNames.VehicleAccident,
})
@Component({
  selector: 'vehicle-accidents-ui-util',
  template: ` 
  `
})
export class VehicleAccidentUiUtilComponent extends DwSectionBaseComponent implements OnDestroy {
   formApi: DwMetaDataFormApi;
   variables: VehicleAccidentsVariableContext;

  constructor(
    dwExpressionService: DwExpressionService,
    protected dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
    private dwFormStateService: DwMetaDataFormStateService
  ) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
    this.formApi = this.dwFormStateService.state.formApi;
  }
  ngOnInit(): void {
    this.loadModes();
  }

  setupComponentComplete() {
    this.runAfterFormDataLoaded(() => this.setupSubscriptions());
  }

  private setupSubscriptions() {
    const requestEntity = this.formApi.getFormData<VehicleAccidentEntity>();
    this.subscriptions.push(this.formApi.getFormDataChanges<VehicleAccidentEntity>(400).subscribe(entity => {
      this.handleUpdate(entity);
    }));
  }
  ngOnDestroy(): void {
    for(const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  modes: DwLookupInfo[] = [];
  private loadModes() {
    this.dwMetaDataService
        .getLookup(AccidentsMetaDataLookups.CodeValueVehicleAccidentFormVersion)
        .subscribe((modes) => this.modes = modes);
  }

  handleUpdate(data: VehicleAccidentEntity) { 
    /* Set entity version correctly on adding new accident reports from now on */
    const isAdd : boolean = this.formConfig.formMode == 'add';
    if (isAdd && this.modes.length > 0 && data.Version != Number(this.modes[1].Id))
      this.formApi.patchFormData({ Version: Number(this.modes[1].Id)  });
    
    //Total Paid Loss='Paid Expense'  +  'Paid - PD' 
    const PhysicalDamageTotalPaidLoss = Number(data.PhysicalDamagePaidExpense ?? 0) + Number(data.PhysicalDamagePaidPd ?? 0);
    //Total O / S Reserve='O/ S Reserve - Exp' + 'O / S Reserve - PD'
    const PhysicalDamageTotalOsReserve = Number(data.PhysicalDamageOsReserveExp ?? 0) + Number(data.PhysicalDamageOsReservePd ?? 0)
    //Net Paid='Total Paid Loss' - ' Total Recovery'
    const PhysicalDamageNetPaid = PhysicalDamageTotalPaidLoss - Number(data.PhysicalDamageTotalRecovery ?? 0);

    //Total Paid Loss='Paid Expense' + 'Paid Ind - PD / LT'
    const LiabilityTotalPaidLoss = Number(data.LiabilityPaidExpense ?? 0) + Number(data.LiabilityPaidIndPdLt ?? 0);
    //Total Paid Ind='Paid Expense' + 'Paid Ind - BI / Med'
    const LiabilityTotalPaidInd = Number(data.LiabilityPaidExpense ?? 0) + Number(data.LiabilityPaidIndBlMed ?? 0);
    //Total O / S Reserve='Total Paid Loss' + 'O/ S Reserve - Exp' + 'O / S Reserve - BI / Med'
    const LiabilityTotalOsReserve = LiabilityTotalPaidLoss + Number(data.LiabilityOsReserveExp ?? 0) + Number(data.LiabilityOsReserveBlMed ?? 0);

    const calcs : VehicleAccidentsVariableContext =
    {
      PhysicalDamageTotalPaidLoss: PhysicalDamageTotalPaidLoss,
      PhysicalDamageTotalOsReserve: PhysicalDamageTotalOsReserve,
      PhysicalDamageNetPaid: PhysicalDamageNetPaid,
      //Total Incurred='Total O/ S Reserve' + 'Net Paid'
      PhysicalDamageTotalIncurred: PhysicalDamageTotalOsReserve + PhysicalDamageNetPaid,

      LiabilityTotalPaidInd:  LiabilityTotalPaidInd,
      LiabilityTotalPaidLoss: LiabilityTotalPaidLoss,
      LiabilityTotalOsReserve: LiabilityTotalOsReserve,
      //Net Paid='Total Paid Ind' - 'Total O/S Reserve'
      LiabilityNetPaid: LiabilityTotalPaidInd - LiabilityTotalOsReserve,
      //Total Incurred='O/S Reserve - PD / LT' + 'Total Recovery'
      LiabilityTotalIncurred: Number(data.LiabilityOsReservePdLt ?? 0) + Number(data.LiabilityTotalRecovery ?? 0)
    };
    this.formApi.patchContextData(this.formApi.getFormConfig().variableContextDataKey, calcs);
  }
}
export interface VehicleAccidentsVariableContext {
  PhysicalDamageTotalPaidLoss?: number;
  PhysicalDamageTotalOsReserve?: number;
  PhysicalDamageNetPaid?: number;
  PhysicalDamageTotalIncurred?: number;
  LiabilityTotalPaidInd?: number;
  LiabilityTotalPaidLoss?: number;
  LiabilityTotalOsReserve?: number;
  LiabilityNetPaid?: number;
  LiabilityTotalIncurred?: number;
}
